module.exports = __webpack_public_path__ + "static/img/w5.82c9c95.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/custom/w5.png
// module id = H3hq
// module chunks = 0